import { createRouter, createWebHistory } from 'vue-router';
import LoginPage from './page/auth/LoginPage.vue';
import RegPage from './page/auth/RegPage.vue';
import OtpPage from './page/auth/OtpPage.vue';

import HomeUser from './page/user/HomeUser.vue';
import ProfileUser from './page/user/ProfileUser.vue';
import EditProfile from './page/user/EditProfile.vue';
import VerifyUser from './page/user/VerifyUser.vue';
import WalletUser from './page/user/WalletUser.vue';
import HistoryUser from './page/user/HistoryUser.vue';
import RefUser from './page/user/RefUser.vue';
import NotifUser from './page/user/NotifUser.vue';
import SupportUser from './page/user/SupportUser.vue';
import SupportSend from './page/user/SupportSend.vue';
import SupportMessages from './page/user/SupportMessages.vue';
import WithdrawalUser from './page/user/WithdrawalUser.vue';
import CardUser from './page/user/CardUser.vue';
import AssetsUser from './page/user/AssetsUser.vue';

import HomeAdmin from './page/admin/HomeAdmin.vue';
import UserAdmin from './page/admin/UserAdmin.vue';
import OrderAdmin from './page/admin/OrderAdmin.vue';
import SattingAdmin from './page/admin/SattingAdmin.vue';
import ProductsAdmin from './page/admin/ProductsAdmin.vue';
import SupportAdmin from './page/admin/SupportAdmin.vue';
import SupportMessagesAdmin from './page/admin/SupportMessagesAdmin.vue';
import NotifAdmin from './page/admin/NotifAdmin.vue';
import WithdrawalAdmin from './page/admin/withdrawalAdmin.vue';
import CardAdmin from './page/admin/CardAdmin.vue';

import axios from 'axios';
import PriceUser from './page/user/PriceUser.vue';
import WalletOrder from './page/admin/WalletOrder.vue';
import PriceSetting from './components/admin/PriceSetting.vue';
import AssetsUser2 from './page/user/AssetsUser2.vue';
import DepositUser from './page/user/DepositUser.vue';
import DepositAdmin from './page/admin/DepositAdmin.vue';

const url = process.env.VUE_APP_API_URL;

const routes = [
  { path: '/login', component: LoginPage, meta: { layout: 'page' } },
  { path: '/register', component: RegPage, meta: { layout: 'page' } },
  { path: '/otp', component: OtpPage, meta: { layout: 'page' }, name: 'OtpPage' },

  { path: '/user', component: HomeUser, meta: { layout: 'user' } },
  { path: '/user/profile', component: ProfileUser, meta: { layout: 'user' } },
  { path: '/user/editprofile', component: EditProfile, meta: { layout: 'user' } },
  { path: '/user/verify', component: VerifyUser, meta: { layout: 'user' } },
  { path: '/user/wallet', component: WalletUser, meta: { layout: 'user' } },
  { path: '/user/history', component: HistoryUser, meta: { layout: 'user' } },
  { path: '/user/ref', component: RefUser, meta: { layout: 'user' } },
  { path: '/user/notification', component: NotifUser, meta: { layout: 'user' } },
  { path: '/user/support', component: SupportUser, meta: { layout: 'user' } },
  { path: '/user/sendsupport', component: SupportSend, meta: { layout: 'user' } },
  { path: '/user/supportmessages', component: SupportMessages, meta: { layout: 'user' } },
  { path: '/user/withdrawal', component: WithdrawalUser, meta: { layout: 'user' } },
  { path: '/user/card', component: CardUser, meta: { layout: 'user' } },
  { path: '/user/assets', component: AssetsUser, meta: { layout: 'user' } },
  { path: '/user/price', component: PriceUser, meta: { layout: 'user' } },
  { path: '/user/wallet/me', component: AssetsUser2, meta: { layout: 'user' } },
  { path: '/user/deposit', component: DepositUser, meta: { layout: 'user' } },

  { path: '/admin', component: HomeAdmin, meta: { layout: 'admin' } },
  { path: '/admin/users', component: UserAdmin, meta: { layout: 'admin' } },
  { path: '/admin/orders', component: OrderAdmin, meta: { layout: 'admin' } },
  { path: '/admin/settings', component: SattingAdmin, meta: { layout: 'admin' } },
  { path: '/admin/products', component: ProductsAdmin, meta: { layout: 'admin' } },
  { path: '/admin/support', component: SupportAdmin, meta: { layout: 'admin' } },
  { path: '/admin/supportmsg/:id', component: SupportMessagesAdmin, meta: { layout: 'admin' } },
  { path: '/admin/notif', component: NotifAdmin, meta: { layout: 'admin' } },
  { path: '/admin/withdrawal', component: WithdrawalAdmin, meta: { layout: 'admin' } },
  { path: '/admin/cards', component: CardAdmin, meta: { layout: 'admin' } },
  { path: '/admin/walletorder', component: WalletOrder, meta: { layout: 'admin' } },
  { path: '/admin/priceSetting', component: PriceSetting, meta: { layout: 'admin' } },
  { path: '/admin/deposit', component: DepositAdmin, meta: { layout: 'admin' } },

  {
    path: '/',
    redirect: () => {
      const token = localStorage.getItem('token');
      return token ? '/user' : '/login';
    }
  },

  { path: '/:pathMatch(.*)*', redirect: '/' }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

router.beforeEach(async (to, from, next) => {
  const token = localStorage.getItem('token');

  if (to.meta.layout === 'admin') {
    if (!token) return next('/login');
    try {
      const { data } = await axios.get(`${url}/user/profile`);
      if (data.user.role !== 'ADMIN') return next('/user');
    } catch (e) {
      return next('/login');
    }
  }

  if (to.meta.layout === 'user' && !token) return next('/login');

  next();
});

export default router;
